import React from 'react'
import { useIntl } from 'react-intl'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import OrderUpsellTileWithTracking from 'components/Common/OrderUpsellTileWithTracking'
interface Props {
  carHireUpsellData: App.CarHireUpsell
  variant?: 'compact' | 'default'
  onDismiss?: () => void
}

function CarHireUpsellTile(props: Props) {
  const {
    carHireUpsellData,
    variant = 'default',
    onDismiss,
  } = props
  const intl = useIntl()

  const {
    carHireSearchLink,
  } = carHireUpsellData

  return <OrderUpsellTileWithTracking
    title={intl.formatMessage({
      id: '+BZkolkKPr',
      defaultMessage: 'Hire a car',
      description: 'Title for car hire upsell tile on booking confirmation',
    })}
    subTitle={intl.formatMessage({
      id: 'uKlDfbnEyD',
      defaultMessage: 'Free cancellation available',
      description: 'Subtitle for upsell tile indicating free cancellation',
    })}
    description={intl.formatMessage({
      id: 'LlvgtURpEH',
      defaultMessage: 'Trusted car suppliers and 24/7 support.',
      description: 'Description for car hire upsell tile on booking confirmation',
    })}
    IconComponent={LineCarIcon}
    to={carHireSearchLink}
    analyticsSubject="car_hire"
    variant={variant}
    onDismissClick={onDismiss}
    discountPercentage={carHireUpsellData.discountPercentage}
    hasLoyaltyBonusPoints={carHireUpsellData.hasLoyaltyBonusPoints}
  />
}

export default CarHireUpsellTile
